export type TMargin = {
    top?: number;
    right?: number;
    bottom?: number;
    left?: number;
};

export type TLayout = {
    margin?: TMargin;
};
